module.exports = __webpack_public_path__ + "img/failAuditOrange.129e2d79.png";